<template>
	<div class="card" :style="cardStyle">
		<h2>
			<slot></slot>
		</h2>
	</div>
</template>

<script>
export default {
	name: 'Kachel',
	computed: {
		cardStyle() {
			const getRandomNumber = (min, max) => Math.round(Math.random() * (max - min) + min);

			const one = getRandomNumber(30, 70);
			const two = 100 - one;
			const three = getRandomNumber(30, 70);
			const four = 100 - three;

			const five = getRandomNumber(30, 70);
			const six = getRandomNumber(30, 70);
			const seven = 100 - six;
			const eight = 100 - five;
			
			return {
					borderRadius: `${one}% ${two}% ${three}% ${four}% / ${five}% ${six}% ${seven}% ${eight}%`,
			};
		}
	}
}
</script>

<style scoped>
h2 {
	font-size: 1.5rem;
}

.card {
	flex: 0 0 300px;
	height: 200px;
	box-sizing: border-box;
	background: rgb(0,0,0);
	display: flex;
	justify-content: center;
	align-items: center;
	transition: transform .2s ease-in-out;
}

.card:hover {
	cursor: pointer;
	transform: scale(1.075) rotate(3deg);
}

@media (max-width: 600px) {
  h2 {
    font-size: 1.25rem;
  }

  .card {
    flex: 0 0 250px;
    height: 150px;
  }
}
</style>